<template>
    <form @submit.prevent="validateBeforeSubmit">
        <div class="form-group">
            <b-form-group label="Montant du don">
                <money
                        id="amount"
                        type="text"
                        :class="{
            'form-control': true,
            'is-invalid': !$v.amount.required && $v.amount.$dirty,
            'is-valid': $v.amount.required && $v.amount.$dirty
          }"
                        :state="validateState('amount')"
                        name="amount"
                        v-validate="'required|min_value:1'"
                        v-model="amount"
                        data-vv-as="Montant"
                />
                <b-form-invalid-feedback id="input-amount-feedback">
                    <template
                            v-if="
              !$v.amount.required || !$v.amount.minValue || $v.amount.decimal
            "
                    >
                        Veuillez entrer une montant valide
                    </template>
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Membre qui fait le don" v-if="connected">
                <b-select :state="validateState('donor')" v-model="donor">
                    <b-select-option
                            v-for="member in members"
                            :key="member.id"
                            :value="member.id"
                    >
                        {{ member.firstName }} {{ member.lastName }}
                    </b-select-option>
                    <b-form-invalid-feedback id="input-amount-feedback">
                        <template v-if="!$v.donor.required">
                            Veuillez choisir un donateur.
                        </template>
                    </b-form-invalid-feedback>
                </b-select>
            </b-form-group>

            <b-form-group label="Nom du donateur" v-else>
                <b-form-input
                        v-model="name"
                        type="name"
                        aria-describedby="input-name-feedback"
                        ref="name"
                        :state="validateState('name')"
                />
                <b-form-invalid-feedback id="input-amount-feedback">
                    <template v-if="!$v.name.required || !$v.name.minValue">
                        Veuillez entrer le nom complet du donateur.
                    </template>
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Adresse courriel" v-if="!connected">
                <b-form-input
                        v-model="email"
                        type="email"
                        aria-describedby="input-email-feedback"
                        ref="email"
                        :state="validateState('email')"
                />
                <b-form-invalid-feedback id="input-amount-feedback">
                    <template v-if="!$v.email.required">
                        Veuillez entrer votre adresse courriel pour le reçu.
                    </template>
                    <template v-if="!$v.email.email">
                        Veuillez entrer une adresse courriel valide.
                    </template>
                </b-form-invalid-feedback>
            </b-form-group>

            <div>
                <button class="btn btn-primary" v-if="amount > 0" type="submit">
                    Faire un don de {{ amount | money }}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import _ from 'lodash';
  import french from 'vee-validate/dist/locale/fr';
  import PanierPayer from '@/components/Panier/Panier_Payer.vue';

  const {
    required,
    decimal,
    requiredIf,
    email
  } = require('vuelidate/lib/validators');

  export default {
    name: 'DonForm',
    data() {
      return {
        amount: 0,
        name: null,
        email: null,
        success: false,
        donor: null
      };
    },
    validations: {
      amount: {
        required,
        decimal,
        minValue: 0.01
      },
      email: {
        required: requiredIf(function() {
          return this.$store.getters['account/isConnected'] === false;
        }),
        email
      },
      name: {
        required: requiredIf(function() {
          return this.$store.getters['account/isConnected'] === false;
        }),
        minLength: 6
      },
      donor: {
        required: requiredIf(function() {
          return this.$store.getters['account/isConnected'] === true;
        })
      }
    },
    async beforeMount() {
      await this.getAllMembers();

      const donor = _.find(this.members, m => m.main);
      if (donor) {
        this.donor = donor.id;
      }
    },

    computed: {
      ...mapGetters('account', {
        connected: 'isConnected'
      }),
      members() {
        return this.$store.getters['members/getMembers'];
      }
    },

    methods: {
      ...mapActions('members', {
        getAllMembers: 'fetchMembers'
      }),

      async askCreditCard() {
        this.$modal.show(PanierPayer, {
          onSuccess: (paymentMethod) => this.processDonation(paymentMethod),
          autoAddPaymentMethod: false,
          title: 'Paiement du don',
          name: this.name
        }, {
          height: 'auto',
          width: 500,
          clickToClose: false,
          name: 'don-paiement',
          root: this.$root
        });
      },

      /**
       * Validation formulaire.
       */
      async validateBeforeSubmit(event) {
        await this.$v.$touch();

        // Backend prepare the charge in checkout, then redirect there.
        if (!this.$v.$invalid) {
          await this.askCreditCard();
        }
      },

      async processDonation(paymentMethod) {
        try {
          // Prepare the checkout session
          await this.payDonation({
            amount: this.amount,
            email: this.email,
            donor: this.donor,
            name: this.name,
            paymentMethod: paymentMethod.id
          });

          this.$modal.hide('don-paiement');

          await this.$swal.fire({
            title: 'Succès',
            html: 'Votre don a bien été reçu. Vous recevrez un reçu par courriel dans les prochaines minutes.<br/><br/>Merci!',
            type: 'success',
            confirmButtonText: 'Fermer'
          });
        }
        catch (e) {
          await this.$swal.fire({
            title: 'Problème',
            html:
              'Il semble y avoir un problème avec notre serveur. Veuillez réessayer plus tard ou nous contacter directement. <br /><br />Merci beaucoup.',
            type: 'error',
            confirmButtonText: 'Fermer'
          });
        }
      },

      validateState(name) {
        const { $dirty, $error } = this.$v[name];
        return $dirty ? !$error : null;
      },

      ...mapActions('orders', {
        payDonation: 'payDonation'
      })
    },

    created() {
      this.$validator.localize('fr', {
        messages: french.messages
      });
    }
  };
</script>

<style scoped></style>
